import { render, staticRenderFns } from "./give-proudly-initLayout.vue?vue&type=template&id=37412533&scoped=true"
import script from "./give-proudly-initLayout.vue?vue&type=script&lang=js"
export * from "./give-proudly-initLayout.vue?vue&type=script&lang=js"
import style0 from "./give-proudly-initLayout.vue?vue&type=style&index=0&id=37412533&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37412533",
  null
  
)

export default component.exports